module.exports = __webpack_public_path__ + "static/media/404.7af5ecd5.svg";